// extracted by mini-css-extract-plugin
module.exports = {"columnWrap":"_34ynpxbH_Dhfmxa6gIoYzj","brick":"_3n7VNzG5xs-R47QEVMTiyP","wrap":"_3iwh_3t-Lyki0WsCkJ48iK"};